/**
 * DeviceLogsTab — device activity log. All behavior lives in the shared
 * ProfileLogsTable; this only supplies what differs per entity.
 *
 * Two device-only touches: the actor links to their user profile, and rows
 * with no structured log_info fall back to `source`, which is where the
 * suppression window text lives until deviceSuppression() is migrated.
 */

import ProfileLogsTable from '../../../../components/v2/ProfileLogsTable.jsx';

const DeviceLogsTab = ({ logData, tzOffset, showInternal = true }) => (
  <ProfileLogsTable
    logData={logData}
    tzOffset={tzOffset}
    typeKey="device_log_type_name"
    title="Device Logs"
    linkUsers
    detailFallbackKey="source"
    showInternal={showInternal}
  />
);

export default DeviceLogsTab;
